export default class ColorItHelper {
  static restructureColorcode(colorcode) {
    const pattern = new RegExp(`^[0-9a-fA-F]{6}$`);
    return pattern.test(colorcode) ? `#${colorcode}` : colorcode;
  }
}
